'use client';

import
  Link
from 'next/link';

import
  dynamic
from 'next/dynamic';

import
  SectionLayout
from '@/app/ui/section-layout';

import
  ServiceItem
from '@/app/ui/about/service-item';

import {
  useScrollReveal
} from '@/app/hooks/use-scroll-reveal';

// Fetched at runtime by LottiePlayer, not bundled into JS.
const aboutAnim = '/lottie/about-us-animation.json';

import {
  aboutServices as services
} from '@/app/data/about';

import {
  BRAND_GRADIENT,
  BRAND_GRADIENT_DARK_GLASS,
  PRIMARY_BUTTON_CLASSES
} from '@repo/brand';

const LottiePlayer = dynamic(() => import('@repo/ui/lottie-player'), {
  ssr: false
});

export default function AboutSection() {

  const {
    ref, isVisible
  } = useScrollReveal<HTMLDivElement>();

  return (
    <SectionLayout
      label="Elite Scholars"
      heading="Be the top student in your class, it is possible!"
      description="South Africa's trusted tutoring and academic support partner - serving Grades 1-12 (CAPS, IEB, and Cambridge) and university students. Expert one-on-one tutoring, group revision classes, university and bursary application support, and career guidance. Online nationwide. In-person across Gauteng."
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

        <div>
          <p className="text-sm font-semibold text-[#0a1628] dark:text-white mb-4">
            We tick most circles for our Elite Scholars
          </p>

          <ul className="space-y-3 mb-8">
            {services.map((s) => (
              <ServiceItem key={s.href} label={s.label} href={s.href} />
            ))}
          </ul>

          <Link
            href="/about-us"
            className={`inline-flex items-center gap-3 px-7 py-3.5 ${ PRIMARY_BUTTON_CLASSES } ${ BRAND_GRADIENT_DARK_GLASS }`}
            style={{
              background: BRAND_GRADIENT
            }}
          >
            Learn more
            <span className="sr-only">
              {' '}
              about Elite Scholars
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="w-4 h-4 fill-white">
              <path d="M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z" />
            </svg>
          </Link>
        </div>

        <div ref={ref} className="flex items-center justify-center w-full max-w-md mx-auto aspect-square">
          {isVisible && <LottiePlayer animationPath={aboutAnim} className="w-full h-full" />}
        </div>

      </div>
    </SectionLayout>
  );
}
